import { HttpInterceptorFn, HttpErrorResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { catchError, throwError } from 'rxjs';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  const token = authService.getToken();

  let authReq = req;
  if (token && !req.url.includes('/auth/')) {
    authReq = req.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`
      }
    });
  }

  return next(authReq).pipe(
    catchError((error: HttpErrorResponse) => {
      console.log('Interceptor caught error:', error.status, req.url);
      if (error.status === 401 && !req.url.includes('/auth/')) {
        console.log('Redirecting to login...');
        // Clear auth data without redirect (we'll handle redirect here)
        authService.logout(false);
        // Navigate to login with return URL
        const currentUrl = router.url;
        console.log('Current URL:', currentUrl);
        router.navigate(['/login'], {
          queryParams: { returnUrl: currentUrl !== '/login' ? currentUrl : '/' }
        }).then(success => {
          console.log('Navigation result:', success);
        });
      }
      return throwError(() => error);
    })
  );
};